import React from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { CircleMarker,Popup,Polyline, Marker } from "react-leaflet";
import { useRef, useState } from "react";

import { useSelector } from "react-redux";
import Footer from "./footer";
import Header from "./header";
import { useParams } from 'react-router-dom';
import { CgArrowLongDownC } from 'react-icons/cg';
import { CgShapeCircle } from 'react-icons/cg';
import { IconContext } from 'react-icons/lib';
import Getdata from "./getdata";
import * as L from "leaflet";

import { CSVLink } from "react-csv";






let position;
let processed_location_new;
let calculated_Drift =[];
var marker;
var markers;


function Mapsales() {

  // const [defaultLocation,setDefaultLocation] = useState({val : [28.44372749,77.05503845], asked: false});
  
  
  const csvDownloadRef = useRef(null);

  let { mac, limit, lat_long} = useParams();

    

    

    const apiData = useSelector(state => state.api);

    const processed_data = [...apiData.coordinate];
    // console.log(processed_data);
   

    const processed_lat = [...apiData.lat];
    // console.log(processed_lat);
    // console.log(processed_lat[0]);
    
    const processed_long = [...apiData.long];
    // console.log(processed_long);
    // console.log(processed_long[0]);

    const processed_nos = [...apiData.nos];
    // console.log(processed_nos);

    const processed_h_dop = [...apiData.h_dop];
    // console.log(processed_h_dop);

    const processed_speed = [...apiData.speed];
    // console.log(processed_speed);

    const processed_n_s = [...apiData.n_s];
    // console.log(processed_n_s);

    const processed_e_w = [...apiData.e_w];
    // console.log(processed_e_w);

    const processed_when = [...apiData.when];
    // console.log(processed_when);

    const processed_epoch = [...apiData.epoch];
    // console.log(processed_epoch);




    const processed_humid = [...apiData.map_humidity];
    // console.log(processed_humid)
    let processed_humidity =[];
    processed_humid.forEach(ele =>{
      processed_humidity.push([processed_humid[ele]]);
    });
    // console.log(processed_humidity);

    
    const processed_temperature = [...apiData.map_temperature];
    const processed_lightexposure = [...apiData.map_lightexposure];
    const processed_motion = [...apiData.map_motion];
    const processed_altitude = [...apiData.map_altitude];
    const processed_course = [...apiData.map_course];



    
    const center = processed_data.length>0? processed_data[0]:[28.44372749,77.05503845];

    // const center = defaultLocation.val;

    // if(defaultLocation.asked == false) {
    //   let prompt1 = prompt("ENTER THE CENTER VALUE","28.44372749,77.05503845");
    //   console.log(prompt1);
    //   let newVal = [28.44372749,77.05503845];
    //   try {
    //     if(!prompt1) throw new Error('Bad prompt result'); // if null, empty string or undefined
    //     prompt1 = "[" + prompt1 + "]";
    //     newVal = JSON.parse(prompt1);

    //     // type of newval should be array
    //     // length of newval should be 2
    //     // each element of array should be integer

    //     // console.log("correctly parsed",newVal)
    //   }
    //   catch(e) {
    //     console.log("unable to parse", e);
    //   }
    //   setDefaultLocation({
    //     asked: true,
    //     val: newVal
    //   });
    // }



    

    // const polyline = processed_data.reverse();
    const polyline = processed_data.map((e,i)=>{
      
      

      return {
        coords : e,
        latitude : processed_lat[i],
        longitude : processed_long[i],
        humidity : processed_humid[i],
        temperature : processed_temperature[i],
        lightexposure : processed_lightexposure[i],
        motion : processed_motion[i],
        h_dop : processed_h_dop[i],
        speed : processed_speed[i],
        altitude : processed_altitude[i],
        course : processed_course[i],
        n_s : String.fromCharCode(processed_n_s[i]),             // String.fromCharCode() -> this function is used to convert number into ASCII values
        e_w : String.fromCharCode(processed_e_w[i]),
        nos : processed_nos[i],
        date :new Date(processed_epoch[i]*1000).toISOString(),               // epoch time is in seconds, we are converting it into milliseconds by multiplying by 1000
        marker_no : ++i,

      }
    }).reverse();
    // console.log(polyline);


    


    var myIcon = L.icon({
      iconUrl: 'data:image/svg+xml;base64,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',
      iconSize: [38, 95],
      iconAnchor: [19, 55],
      popupAnchor: [-3, -76],
      // shadowUrl: 'map-icon-shadow.png',
      // shadowSize: [68, 95],
      // shadowAnchor: [22, 94],
  });	


  //   var myIcon = L.icon({
  //     options: {
  //       iconUrl: 'data:image/svg+xml;base64,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',
  //       number : "",
  //       shadowUrl : null,
  //       iconSize: [38, 95],
  //       iconAnchor: [19, 55],
  //       popupAnchor: [-3, -76],
  //       // shadowUrl: 'map-icon-shadow.png',
  //       // shadowSize: [68, 95],
  //       // shadowAnchor: [22, 94],
        
  //       className: 'leaflet-div-icon',
      
  //     },

  //     createIcon: function () {
  //       var div = document.createElement('div');
  //       var img = this._createImg(this.options['iconUrl']);
  //       var numdiv = document.createElement('div');
  //       numdiv.setAttribute ( "class", "number" );
  //       numdiv.innerHTML = this.options['number'] || '';
  //       div.appendChild ( img );
  //       div.appendChild ( numdiv );
  //       this._setIconStyles(div, 'icon');
  //       return div;
  //     },
      
  //     createShadow: function () {
  //       return null;
  //     }
      

      
  // });


    const download_CSV = () =>{
      

        calculated_Drift = [];

      for (let i = 0; i < processed_data.length; i++) {

        function toRad(x) {
          return x * Math.PI / 180;
        }
          
  
            // JavaScript program to calculate Distance Between
            // Two Points on Earth
  
        function distance(lat1,lat2, lon1, lon2)
        {
          
  
          // Haversine formula
          let x2 = lon2 - lon1;
          let dLon = toRad(x2) ;
          let x1 = lat2 - lat1;
          let dLat = toRad(x1);
          let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
          Math.sin(dLon / 2) * Math.sin(dLon / 2);
            
          let c =  2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  
          // Radius of earth in kilometers. Use 3956
          // for miles
          let r = 6371*1000;
  
          // calculate the result
          return(c * r);
        }
  
        // Driver code
          
          let lat1 = processed_lat[0];
          let lat2 = processed_lat[i];
          let lon1 = processed_long[0];
          let lon2 = processed_long[i];
          let calculated_Distance = distance(lat1, lat2,lon1, lon2);
          // console.log(calculated_Distance + " M");
          
          calculated_Drift.push({ "center" : center,
                                  "latitude" : processed_lat[i],
                                  "longitude" : processed_long[i],
                                  "Drift in Meter" : calculated_Distance,
                                  "NOS" : processed_nos[i],
                                  "H_DOP" : processed_h_dop[i],
                                  "SPEED" : processed_speed[i],
                                  "NORTH_SOUTH" : processed_n_s[i],
                                  "EAST_WEST" : processed_e_w[i],
                                  "DATE_TIME" : processed_when[i],
                                  "EPOCH in seconds" : processed_epoch[i]
                                });
  
      }
  
      // console.log(calculated_Drift);

      setTimeout(()=>{
      csvDownloadRef.current.link.click();


      },3000)

      

    };
    
    


    
    

const fillBlueOptions = { fillColor: 'blue' }
const blackOptions = { color: 'black' }
const limeOptions = { color: 'lime' }
const purpleOptions = { color: 'purple' }
const redOptions = { color: 'red' }

const listItems = polyline.map((ele) =>



// markers = L.markerClusterGroup(),
//       marker = L.latLng(ele.coords),

//       markers.addLayer(marker),
//       map.addLayer(markers),

 <CircleMarker center={ele.coords} pathOptions={purpleOptions} radius={5} eventHandlers={{
  mouseover: (event) => event.target.openPopup(),
  mouseout: (event) => event.target.closePopup()
  }}  stroke={false} > 
    {/* var marker = new L.Marker(ele.coords, { icon =	new L.myIcon({number: ele.marker_no})
    }); */}
    
    <Marker position={ele.coords} icon={myIcon} eventHandlers={{
  mouseover: (event) => event.target.openPopup(),
  mouseout: (event) => event.target.closePopup()
  }}>

      

    <Popup>{/* Coordinates : {String(ele.coords)} */}Marker No : {ele.marker_no} <br/> <br/> Lat : {ele.latitude}, <br/> N_S : {ele.n_s}, <br/> Lon : {ele.longitude}, <br/> E_W : {ele.e_w}, <br/> Humidity : {ele.humidity},<br/> Temperature : {ele.temperature},<br/> ALS : {ele.lightexposure},<br/> Evt : {ele.motion}, <br/> H_DOP : {ele.h_dop}, <br/> Speed : {ele.speed}, <br/> Altitude : {ele.altitude}, <br/> Course : {ele.course}, <br/> NoS : {ele.nos}, <br/> Date : {ele.date.split("T")[0]}, Time : {ele.date.split("T")[1].split(".000Z")}  </Popup>
  </Marker>

    {/* <Popup>Coordinates : {String(ele.coords)} Lat : {ele.latitude}, <br/> N_S : {ele.n_s}, <br/> Lon : {ele.longitude}, <br/> E_W : {ele.e_w}, <br/> Humidity : {ele.humidity},<br/> Temperature : {ele.temperature},<br/> ALS : {ele.lightexposure},<br/> Evt : {ele.motion}, <br/> H_DOP : {ele.h_dop}, <br/> Speed : {ele.speed}, <br/> Altitude : {ele.altitude}, <br/> Course : {ele.course}, <br/> NoS : {ele.nos} </Popup> */}
</CircleMarker>
  
);

// L.Circle({center},{
//   color: 'streetblue',
//   radius: 100,
//   fillColor: 'streetblue',
//   opacity: 0.5,
// }).addTo(this.map)






  return (
    <>  
        <Getdata mac={mac} limit={limit}/>
        <Header mac={mac} limit={limit} csv={download_CSV}  />

        <div className="map_page_main_div">
          <MapContainer center={center} zoom={16} scrollWheelZoom={true}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              
            />
            
              {/* <MarkerClusterGroup> */}
                <Polyline pathOptions={blackOptions} positions={processed_data.reverse()} stroke={false} >
                    {listItems}
                </Polyline>  
              {/* </MarkerClusterGroup> */}
            
            
          </MapContainer>
        </div>
      

        <div>
          <CSVLink
              data={calculated_Drift}
              filename="Drifting_distance.csv"
              target="_blank"
              ref={csvDownloadRef}/>

              {/* {console.log(apiData.humidity)} */}

                {/* <button className="btn-drift-csv" onClick={download_CSV}>Download Drift CSV</button> */}
        </div>

        <div id="mapfooter">
         <Footer mac={mac} limit={limit}  />
        </div>
    </>
  );
}

export default Mapsales;
